import React from 'react'
import { Button } from 'react-bootstrap'
import { getPoiTypeLabel } from '../utils/utils'
import { useLanguage } from '../contexts/LanguageContext'

const PoiTypeMultiSelect = ({
  poiTypes,
  selectedPoiTypes,
  handleButtonClick,
}) => {
  const { activeLanguage } = useLanguage()

  return (
    <div className="text-center p-3">
      {poiTypes.map((poiType) => {
        const buttonClass = `btn btn-poi-type-${poiType.name} btn-poi-type ${
          selectedPoiTypes.includes(poiType.name) ? 'selected' : 'unselected'
        }`

        return (
          <Button
            key={poiType.name}
            onClick={() => handleButtonClick(poiType.name)}
            className={buttonClass}
            variant=""
          >
            {getPoiTypeLabel(poiTypes, poiType.name, activeLanguage)}
          </Button>
        )
      })}
    </div>
  )
}

export default PoiTypeMultiSelect
